'use client'

import { ErrorMessage } from '@hookform/error-message'
import { type FC } from 'react'
import { useFormContext } from 'react-hook-form'

type BaseHookFormErrorMessageProps = {
  'data-qa-id'?: string
  name: string
}

/**
 * A wrapper component for displaying error messages in forms using React Hook Form
 */
export const BaseHookFormErrorMessage: FC<BaseHookFormErrorMessageProps> = ({
  'data-qa-id': dataQaId,
  name,
}) => {
  const {
    formState: { errors },
  } = useFormContext()

  return (
    <ErrorMessage
      errors={errors}
      name={name}
      render={({ message }) =>
        message ? (
          <div className="self-stretch text-dark-error" data-qa-id={dataQaId}>
            {message}
          </div>
        ) : null
      }
    />
  )
}
